import { sql } from 'drizzle-orm';
import {
  pgTable,
  index,
  jsonb,
  timestamp,
  varchar,
  text,
  boolean,
  uuid,
  primaryKey
} from "drizzle-orm/pg-core";
import { organizations } from './organizations';

// Saved Reports table - stores user's favorite report configurations
export const savedReports = pgTable("saved_reports", {
  id: uuid("id").primaryKey().default(sql`gen_random_uuid()`),
  userId: varchar("user_id").notNull(), // References users.id
  name: varchar("name", { length: 255 }).notNull(),
  description: text("description"),
  selectedFields: jsonb("selected_fields").notNull(), // Array of field IDs
  filters: jsonb("filters").notNull(), // Filter configuration object
  isDefault: boolean("is_default").default(false), // If true, load this report by default

  orgId: uuid("org_id").references(() => organizations.id, { onDelete: "cascade" }),

  createdAt: timestamp("created_at").defaultNow(),
  updatedAt: timestamp("updated_at").defaultNow(),
}, (table) => [
  index("idx_saved_reports_user").on(table.userId),
]);
